import React from "react";
import "./calcInputs.css";
import CreditLengthChangeData from "./creditLenghtChangeData";
import MarginChangeData from "./marginChangeData";
import CreditSubsequentsTranchesChangeData from "./creditSubsequentsTranchesChangeData";
import CreditEarlyRepaymentChangeData from "./creditEarlyRepaymentChangeData";
import ConstProcViewer from "./constProcViewer";

const calcInputs = (props) => {
  const checkFunction = (key) => {
    var check = props.additionalFunctions.filter((el) => el.key === key);
    if (check.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <div className="inputsBox">
        <h1 className="calcTitle">
          Wprowadź dane{" "}
          {props.creditTypeText === "kredyt" ? "kredytu" : "pożyczki"}{" "}
          {props.creditCurrency}
        </h1>
        {checkFunction("specialTemplates") ? (
          <>
            <div className="titleBox">
              <div className="titleCol1">
                <h2 className="calcSubtitle">Dane analizy</h2>
              </div>
              <div className="titleCol2">
                <hr />
              </div>
            </div>
            <div className="fullRow">
              <div className="mainRow">
                <div className="row">
                  {checkFunction("specialTemplates") ? (
                    <div className="rCol1_5">
                      <label htmlFor="creditValue">Rodzaj szablonu</label>
                      <select
                        name="creditPaymentType"
                        id="creditPaymentType"
                        className="currencySelect"
                        value={props.specialTemplate}
                        onChange={props.handleSpecialTemplateChange}
                      >
                        {+props.companyId === 109 &&
                        props.analysisType === "wib" ? (
                          ""
                        ) : (
                          <option value="default">Standardowa</option>
                        )}

                        {props.specialTemplates.length === 0
                          ? ""
                          : props.specialTemplates
                              .filter((el) => el.type === props.analysisType)
                              .map((el2) => (
                                <>
                                  <option value={el2.name}>{el2.name}</option>
                                </>
                              ))}
                      </select>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
        <form id="calcForm" noValidate>
          <div className="titleBox">
            <div className="titleCol1">
              <h2 className="calcSubtitle">Dane klienta</h2>
            </div>
            <div className="titleCol2">
              <hr />
            </div>
          </div>
          <div className="fullRow">
            <div className="mainRow">
              <div className="row">
                {checkFunction("offerType") ? (
                  <div className="rCol1_5">
                    <label htmlFor="creditValue">Rodzaj oferty</label>
                    <select
                      name="creditPaymentType"
                      id="creditPaymentType"
                      className="currencySelect"
                      value={props.offerType}
                      onChange={props.handleOfferTypeChange}
                    >
                      <option value="default">Standardowa</option>
                      <option value="pchf">Porównywarka CHF</option>
                    </select>
                  </div>
                ) : (
                  ""
                )}
                {checkFunction("additionalOffer") ? (
                  <>
                    <div className="rCol3_2">
                      <div className="checkbFlex">
                        <label id="chbLabel" htmlFor="creditValue">
                          <input
                            id="chb"
                            type="checkbox"
                            checked={props.guarantee}
                            onChange={props.handleGuaranteeChange}
                          />
                          Gwarancja wygranej sprawy
                        </label>
                      </div>
                    </div>
                    <div className="rCol3_2">
                      <div className="checkbFlex">
                        <label id="chbLabel" htmlFor="creditValue">
                          <input
                            id="chb"
                            type="checkbox"
                            checked={props.costs}
                            onChange={props.handleCostsChange}
                          />
                          Koszty po stronie kancelarii
                        </label>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <div className="fullRow">
            <div className="mainRow">
              {props.analysisType === "skd" && checkFunction("wiborTypeSKD") ? (
                <>
                  <div className="rCol1_3">
                    <label
                      htmlFor="creditPaymentType"
                      className="creditPaymentType"
                    >
                      Rodzaj WIBOR
                    </label>
                    <select
                      name="creditPaymentType"
                      id="creditPaymentType"
                      className="currencySelect"
                      value={props.wiborType}
                      onChange={props.handleWiborTypeChange}
                    >
                      <option value="Wibor 1M">Wibor 1M</option>
                      <option value="Wibor 3M">Wibor 3M</option>
                      <option value="Wibor 6M">Wibor 6M</option>
                      <option value="Wibor 12M">Wibor 12M</option>
                      <option value="Stopa referencyjna">
                        Stopa referencyjna
                      </option>
                    </select>
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="fullRow">
            <div className="mainRow">
              <div className="row">
                {props.analysisType !== "wib" ? (
                  <div className="rCol1_3">
                    <label
                      htmlFor="creditPaymentType"
                      className="creditPaymentType"
                    >
                      Rodzaj zobowiązania
                    </label>
                    <select
                      name="creditPaymentType"
                      id="creditPaymentType"
                      className="currencySelect"
                      value={props.creditTypeText}
                      onChange={props.handleCreditTypeTextChange}
                    >
                      <option value="pożyczka">pożyczka</option>
                      <option value="kredyt">kredyt</option>
                    </select>
                  </div>
                ) : (
                  <div className="rCol1_3">
                    <label
                      htmlFor="creditPaymentType"
                      className="creditPaymentType"
                    >
                      Rodzaj WIBOR
                    </label>
                    <select
                      name="creditPaymentType"
                      id="creditPaymentType"
                      className="currencySelect"
                      value={props.wiborType}
                      onChange={props.handleWiborTypeChange}
                    >
                      <option value="Wibor 1M">Wibor 1M</option>
                      <option value="Wibor 3M">Wibor 3M</option>
                      <option value="Wibor 6M">Wibor 6M</option>
                      <option value="Wibor 12M">Wibor 12M</option>
                    </select>
                  </div>
                )}
                <div className="rCol1">
                  <label htmlFor="clientName">
                    Imię i nazwisko klienta{" "}
                    <span className="requiredStar">*</span>
                    <input
                      type="text"
                      id="clientName"
                      name="clientName"
                      value={props.clientName}
                      onChange={props.handleClientNameChange}
                    />
                  </label>
                  <p
                    className={
                      props.errorName === 1 ? "errorNameShow" : "errorNameHide"
                    }
                  >
                    To pole nie moe być puste
                  </p>
                </div>
                <div className="rCol2">
                  <label htmlFor="clientPhone">
                    Numer telefonu klienta
                    <input
                      type="tel"
                      maxLength="9"
                      id="clientPhone"
                      name="clientPhone"
                      value={props.clientPhone}
                      onChange={props.handleClientPhoneChange}
                    />
                  </label>
                  <p
                    className={
                      props.errorPhone === 1
                        ? "errorPhoneShow"
                        : "errorPhoneHide"
                    }
                  >
                    Nieprawidłowy numer telefonu
                  </p>
                </div>
                <div className="rCol3">
                  <label htmlFor="clientMail">
                    Adres e-mail
                    <input
                      type="text"
                      id="clientMail"
                      name="clientMail"
                      value={props.clientMail}
                      onChange={props.handleClientMailChange}
                    />
                  </label>
                  <p
                    className={
                      props.errorMail === 1 ? "errorMailShow" : "errorMailHide"
                    }
                  >
                    Nieprawidłowy adres e-mail
                  </p>
                </div>
              </div>
            </div>

            <div className="icoBox">
              <img
                src="./assets/user.png"
                className="ico"
                alt="Frankmierz"
              ></img>
            </div>
          </div>

          <div className="titleBox">
            <div className="titleCol1">
              <h2 className="calcSubtitle">
                szczegóły{" "}
                {props.creditTypeText === "kredyt" ? "kredytu" : "pożyczki"}
              </h2>
            </div>
            <div className="titleCol2">
              <hr />
            </div>
          </div>

          <div className="fullRow">
            <div className="mainRow">
              <div className="row">
                <div className="rCol1_4">
                  <label htmlFor="credit_bank">
                    Wybierz bank <span className="requiredStar">*</span>
                  </label>
                  <select
                    name="pets"
                    id="credit_bank"
                    onChange={props.handleAgreementChange}
                    value={props.clientAgreement}
                  >
                    <option value="Wybierz...">
                      Wybierz umowę zgodną z dokumentacją{" "}
                      {props.creditTypeText === "kredyt"
                        ? "kredytu"
                        : "pożyczki"}
                    </option>
                    {props.analysisType === "chf" ||
                    props.analysisType === "eur" ||
                    props.analysisType === "dol"
                      ? props.optionsAgreements.map((agreement) =>
                          agreement.allowedCompany === props.companyId ||
                          agreement.allowedCompany === "all" ? (
                            <option
                              key={agreement.id}
                              value={agreement.agreement}
                            >
                              {agreement.agreement}
                            </option>
                          ) : (
                            ""
                          )
                        )
                      : props.analysisType === "wib" ||
                        props.analysisType === "skd"
                      ? props.optionsAgreements.map((agreement) =>
                          agreement.allowedCompany === props.companyId ||
                          agreement.allowedCompany === "wib" ? (
                            <option
                              key={agreement.id}
                              value={agreement.agreement}
                            >
                              {agreement.agreement}
                            </option>
                          ) : (
                            ""
                          )
                        )
                      : ""}
                  </select>
                  {props.analysisType !== "wib" ? (
                    <div className="agreementsBox">
                      <button
                        className="buttonAgreements"
                        onClick={props.handleShowAgreementPointsDetails}
                        disabled={
                          props.chooseAgreementPointer === 1 ? false : true
                        }
                      >
                        {props.expandStyleAgreement === 1
                          ? "UKRYJ KLAUZULE NIEDOZOWLONE W UMOWIE"
                          : "POKAŻ KLAUZULE NIEDOZOWLONE W UMOWIE"}
                      </button>
                      <div
                        className={
                          props.expandStyleAgreement === 1
                            ? "agreementsDetailsBoxShow"
                            : "agreementsDetailsBoxHide"
                        }
                      >
                        <div className="agreementDetailTextAreaBox">
                          <textarea
                            className="agreementDetailTextBox"
                            id="agreement_details"
                            name="agreement_details"
                            onChange={props.handleAgreementDetailsTextChange}
                            value={props.agreementDetailsText}
                          />
                          <p className="editInfo">
                            edytuj tekst, aby zmienić treść w wygenerowanej
                            analizie
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="row">
                <div className="rCol1_5">
                  <label htmlFor="creditValue">
                    Kwota{" "}
                    {props.creditTypeText === "kredyt" ? "kredytu" : "pożyczki"}{" "}
                    <span className="requiredStar">*</span>
                  </label>
                  <input
                    type="number"
                    pattern="\d+"
                    min={0}
                    step={0.1}
                    id="creditValue"
                    name="creditValue"
                    value={props.creditValue}
                    onChange={props.handleCreditValueChange}
                    onFocus={props.handleFocus}
                  />
                  <p
                    className={
                      props.errorCreditValue === 1
                        ? "errorCreditValueShow"
                        : "errorCreditValueHide"
                    }
                  >
                    Nieprawidłowa kwota{" "}
                    {props.creditTypeText === "kredyt" ? "kredytu" : "pożyczki"}
                  </p>
                </div>
                <div className="rCol2_5">
                  <label htmlFor="creditCurrency" className="currencyTitle">
                    Wybierz walutę wypłaty{" "}
                    {props.creditTypeText === "kredyt" ? "kredytu" : "pożyczki"}{" "}
                    <span className="requiredStar">*</span>
                  </label>
                  <select
                    name="creditCurrency"
                    id="creditCurrency"
                    className="currencySelect"
                    value={props.creditCurrency}
                    onChange={props.handleCreditCurrencyChange}
                  >
                    {props.analysisType === "chf" ? (
                      <option value="CHF">CHF</option>
                    ) : props.analysisType === "eur" ? (
                      <option value="EUR">EUR</option>
                    ) : props.analysisType === "dol" ? (
                      <option value="DOL">USD</option>
                    ) : (
                      ""
                    )}
                    <option value="PLN">PLN</option>
                  </select>
                </div>
                {checkFunction("constRemainedDebtValue") &&
                props.analysisType !== "wib" &&
                props.analysisType !== "skd" ? (
                  <div className="rCol1_5">
                    <label htmlFor="creditValue">
                      Pozostałe saldo{" "}
                      {props.creditTypeText === "kredyt"
                        ? "kredytu"
                        : "pożyczki"}{" "}
                      (PLN) <span className="requiredStar">*</span>
                    </label>
                    <input
                      type="number"
                      pattern="\d+"
                      min={0}
                      step={0.1}
                      id="creditValue"
                      name="creditValue"
                      value={props.constRemainedDebtValue}
                      onChange={props.handleConstRemainedDebtValue}
                      onFocus={props.handleFocus}
                    />
                    <p
                      className={
                        props.errorConstRemainedDebtValue === 1
                          ? "errorCreditValueShow"
                          : "errorCreditValueHide"
                      }
                    >
                      Nieprawidłowa kwota pozostałego salda{" "}
                      {props.creditTypeText === "kredyt"
                        ? "kredytu"
                        : "pożyczki"}
                    </p>
                  </div>
                ) : (
                  ""
                )}
                {props.analysisType === "skd" ? (
                  <div className="rCol1_5">
                    <label htmlFor="creditValue">Prowizja (PLN)</label>
                    <input
                      type="number"
                      pattern="\d+"
                      min={0}
                      step={0.1}
                      id="creditValue"
                      name="creditValue"
                      value={props.comission}
                      onChange={props.handleComission}
                      onFocus={props.handleFocus}
                    />
                    <p
                      className={
                        props.errorComission === 1
                          ? "errorCreditValueShow"
                          : "errorCreditValueHide"
                      }
                    >
                      Nieprawidłowa kwota prowizji{" "}
                    </p>
                  </div>
                ) : (
                  ""
                )}
              </div>

              <div className="row">
                <div className="rCol1_3">
                  <label htmlFor="creditDate">
                    Data udzielenia{" "}
                    {props.creditTypeText === "kredyt" ? "kredytu" : "pożyczki"}{" "}
                    <span className="requiredStar">*</span>
                  </label>
                  <input
                    type="date"
                    id="creditDate"
                    name="creditDate"
                    value={props.creditDate}
                    onChange={props.handleCreditDateChange}
                    min="2002-01-01"
                  />
                </div>
                <div className="rCol2_3">
                  <label htmlFor="creditMargin">
                    Marza banku (wyrazona w %){" "}
                    <span className="requiredStar">*</span>
                  </label>
                  <input
                    type="number"
                    pattern="\d+"
                    min={0}
                    max={100}
                    step={0.1}
                    id="creditMargin"
                    name="creditMargin"
                    value={props.creditMargin}
                    onChange={props.handleCreditMarginChange}
                    onFocus={props.handleFocus}
                  />
                  <p
                    className={
                      props.errorCreditMargin === 1
                        ? "errorCreditMarginShow"
                        : "errorCreditMarginHide"
                    }
                  >
                    Nieprawidłowa wartość marzy
                  </p>
                </div>
                <div className="rCol3_3">
                  <label htmlFor="creditLength">
                    Okres{" "}
                    {props.creditTypeText === "kredyt"
                      ? "kredytowania"
                      : "pożyczki"}{" "}
                    (msc) <span className="requiredStar">*</span>
                  </label>
                  <input
                    type="number"
                    pattern="\d+"
                    min={0}
                    max={1000}
                    step={1}
                    id="creditLength"
                    name="creditLength"
                    value={props.creditLength}
                    onChange={props.handleCreditLengthChange}
                    onFocus={props.handleFocus}
                  />
                  <p
                    className={
                      props.errorCreditLength === 1
                        ? "errorCreditLengthShow"
                        : "errorCreditLengthHide"
                    }
                  >
                    Nieprawidłowa długość okresu kredytowania
                  </p>
                </div>
              </div>
            </div>

            <div className="icoBox">
              <img
                src="./assets/calc.png"
                className="ico"
                alt="Frankmierz"
              ></img>
            </div>
          </div>

          <div className="titleBox">
            <div className="titleCol1_2">
              <h2 className="calcSubtitle">Dane dodatkowe</h2>
            </div>
            <div className="titleCol2_2">
              <hr />
            </div>
            <div className="titleCol3_2">
              <button
                className="buttonExpand"
                onClick={props.expandAdditionalData}
              >
                {props.expandStyle === 1 ? "ZWIŃ" : "ROZWIŃ"}
              </button>
            </div>
          </div>

          <div
            className="fullRow"
            id={
              props.expandStyle === 1
                ? "additionalDataShow"
                : "additionalDataHide"
            }
          >
            <div className="mainRow">
              <div className="row">
                <div className="rCol1_3">
                  <label
                    htmlFor="creditPaymentType"
                    className="creditPaymentType"
                  >
                    Wybierz rodzaj spłaty rat
                  </label>
                  <select
                    name="creditPaymentType"
                    id="creditPaymentType"
                    className="currencySelect"
                    value={props.creditPaymentType}
                    onChange={props.handleCreditPaymentTypeChange}
                  >
                    <option value="równe">równe</option>
                    <option value="malejące">malejące</option>
                  </select>
                </div>
                {props.analysisType !== "wib" ? (
                  <div className="rCol2_3">
                    <label htmlFor="creditSpread">
                      Wysokość spreadu (wyrazona w %)
                    </label>
                    <input
                      type="number"
                      pattern="\d+"
                      min={0}
                      max={100}
                      step={0.1}
                      id="creditSpread"
                      name="creditSpread"
                      value={props.creditSpread}
                      onChange={props.handleCreditSpreadChange}
                      onFocus={props.handleFocus}
                    />
                    <p
                      className={
                        props.errorCreditSpread === 1
                          ? "errorCreditSpreadShow"
                          : "errorCreditSpreadHide"
                      }
                    >
                      Nieprawidłowa wartość spreadu
                    </p>
                  </div>
                ) : (
                  ""
                )}

                <div className="rCol3_3">
                  <label htmlFor="creditLength">
                    Karencja spłaty{" "}
                    {props.creditTypeText === "kredyt" ? "kredytu" : "pożyczki"}
                  </label>
                  <input
                    type="number"
                    pattern="\d+"
                    min={0}
                    step={1}
                    id="creditGracePeriod"
                    name="creditGracePeriod"
                    value={props.creditGracePeriod}
                    onChange={props.handleCreditGracePeriodChange}
                    onFocus={props.handleFocus}
                  />
                </div>
              </div>

              <div className="rowBlock">
                <div className="inputTitle">
                  Zmiana okresu{" "}
                  {props.creditTypeText === "kredyt"
                    ? "kredytowania"
                    : "pożyczki"}{" "}
                  (jezeli skrócono - podaj wartość ujemną) [max: 15]
                </div>
                <div className="subRow">
                  <form className="subForm" id="changeLength" noValidate>
                    <div className="rCol1_3">
                      <label htmlFor="actualCreditLengthChangeRowDate">
                        Data
                      </label>
                      <input
                        type="date"
                        id="actualCreditLengthChangeRowDate"
                        name="actualCreditLengthChangeRowDate"
                        value={props.actualCreditLengthChangeRowDate}
                        onChange={
                          props.handleActualCreditLengthChangeRowDateChange
                        }
                        min="2002-01-01"
                      />
                    </div>
                    <div className="rCol2_3">
                      <label htmlFor="creditLength">Wartość</label>
                      <input
                        type="number"
                        pattern="\d+"
                        id="actualCreditLengthChangeRowValue"
                        name="actualCreditLengthChangeRowValue"
                        value={props.actualCreditLengthChangeRowValue}
                        onChange={
                          props.handleActualCreditLengthChangeRowValueChange
                        }
                        onFocus={props.handleFocus}
                      />
                    </div>
                    <div className="rCol3_3">
                      <button
                        className="buttonSubForm"
                        onClick={props.handleAddCreditLengthChange}
                      >
                        DODAJ
                      </button>
                    </div>
                  </form>
                </div>
                <div className="subRow">
                  <CreditLengthChangeData
                    creditLengthChanges={props.creditLengthChanges}
                    handleDeleteCreditLengthChange={
                      props.handleDeleteCreditLengthChange
                    }
                  />
                </div>
              </div>
              {props.analysisType === "wib" ? (
                <div className="rowBlock">
                  <div className="inputTitle">
                    Stałe oprocentowanie [max: 15]
                  </div>
                  <div className="subRow">
                    <form className="subForm" id="changeMargin" noValidate>
                      <div className="rCol1_3">
                        <label htmlFor="actualCreditMarginChangeRowDate">
                          Data od
                        </label>
                        <input
                          type="date"
                          id="actualCreditMarginChangeRowDate"
                          name="actualCreditMarginChangeRowDate"
                          value={props.actualConstProcDateFrom}
                          onChange={props.handleActualConstProcDateFromChange}
                          min="2002-01-01"
                        />
                      </div>
                      <div className="rCol1_3">
                        <label htmlFor="actualCreditMarginChangeRowDate">
                          Data do
                        </label>
                        <input
                          type="date"
                          id="actualCreditMarginChangeRowDate"
                          name="actualCreditMarginChangeRowDate"
                          value={props.actualConstProcDateTo}
                          onChange={props.handleActualConstProcDateToChange}
                          min="2002-01-01"
                        />
                      </div>
                      <div className="rCol2_3">
                        <label htmlFor="actualCreditMarginChangeRowValue">
                          Wartość (wyrazona w %)
                        </label>
                        <input
                          type="number"
                          pattern="\d+"
                          id="actualCreditMarginChangeRowValue"
                          name="actualCreditMarginChangeRowValue"
                          value={props.actualConstProcValue}
                          onChange={props.handleActualConstProcValueChange}
                          onFocus={props.handleFocus}
                        />
                      </div>
                      <div className="rCol3_3">
                        <button
                          className="buttonSubForm"
                          onClick={props.handleAddConstProc}
                        >
                          DODAJ
                        </button>
                      </div>
                    </form>
                  </div>
                  <div className="subRow">
                    <ConstProcViewer
                      constProc={props.constProc}
                      handleDeleteConstProc={props.handleDeleteConstProc}
                    />
                  </div>
                </div>
              ) : (
                ""
              )}
              {props.analysisType === "skd" && checkFunction("constProcSKD") ? (
                <div className="rowBlock">
                  <div className="inputTitle">
                    Stałe oprocentowanie [max: 15]
                  </div>
                  <div className="subRow">
                    <form className="subForm" id="changeMargin" noValidate>
                      <div className="rCol1_3">
                        <label htmlFor="actualCreditMarginChangeRowDate">
                          Data od
                        </label>
                        <input
                          type="date"
                          id="actualCreditMarginChangeRowDate"
                          name="actualCreditMarginChangeRowDate"
                          value={props.actualConstProcDateFrom}
                          onChange={props.handleActualConstProcDateFromChange}
                          min="2002-01-01"
                        />
                      </div>
                      <div className="rCol1_3">
                        <label htmlFor="actualCreditMarginChangeRowDate">
                          Data do
                        </label>
                        <input
                          type="date"
                          id="actualCreditMarginChangeRowDate"
                          name="actualCreditMarginChangeRowDate"
                          value={props.actualConstProcDateTo}
                          onChange={props.handleActualConstProcDateToChange}
                          min="2002-01-01"
                        />
                      </div>
                      <div className="rCol2_3">
                        <label htmlFor="actualCreditMarginChangeRowValue">
                          Wartość (wyrazona w %)
                        </label>
                        <input
                          type="number"
                          pattern="\d+"
                          id="actualCreditMarginChangeRowValue"
                          name="actualCreditMarginChangeRowValue"
                          value={props.actualConstProcValue}
                          onChange={props.handleActualConstProcValueChange}
                          onFocus={props.handleFocus}
                        />
                      </div>
                      <div className="rCol3_3">
                        <button
                          className="buttonSubForm"
                          onClick={props.handleAddConstProc}
                        >
                          DODAJ
                        </button>
                      </div>
                    </form>
                  </div>
                  <div className="subRow">
                    <ConstProcViewer
                      constProc={props.constProc}
                      handleDeleteConstProc={props.handleDeleteConstProc}
                    />
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="rowBlock">
                <div className="inputTitle">Zmiana marzy [max: 15]</div>
                <div className="subRow">
                  <form className="subForm" id="changeMargin" noValidate>
                    <div className="rCol1_3">
                      <label htmlFor="actualCreditMarginChangeRowDate">
                        Data
                      </label>
                      <input
                        type="date"
                        id="actualCreditMarginChangeRowDate"
                        name="actualCreditMarginChangeRowDate"
                        value={props.actualCreditMarginChangeRowDate}
                        onChange={
                          props.handleActualCreditMarginChangeRowDateChange
                        }
                        min="2002-01-01"
                      />
                    </div>
                    <div className="rCol2_3">
                      <label htmlFor="actualCreditMarginChangeRowValue">
                        Wartość (wyrazona w %)
                      </label>
                      <input
                        type="number"
                        pattern="\d+"
                        id="actualCreditMarginChangeRowValue"
                        name="actualCreditMarginChangeRowValue"
                        value={props.actualCreditMarginChangeRowValue}
                        onChange={
                          props.handleActualCreditMarginChangeRowValueChange
                        }
                        onFocus={props.handleFocus}
                      />
                    </div>
                    <div className="rCol3_3">
                      <button
                        className="buttonSubForm"
                        onClick={props.handleAddCreditMarginChange}
                      >
                        DODAJ
                      </button>
                    </div>
                  </form>
                </div>
                <div className="subRow">
                  <MarginChangeData
                    creditMarginChanges={props.creditMarginChanges}
                    handleDeleteCreditMarginChange={
                      props.handleDeleteCreditMarginChange
                    }
                  />
                </div>
              </div>

              <div className="rowBlock">
                <div className="inputTitle">
                  Kolejne transze{" "}
                  {props.creditTypeText === "kredyt" ? "kredytu" : "pożyczki"}{" "}
                  [max: 15]
                </div>
                <div className="subRow">
                  <form className="subForm" id="changeLength" noValidate>
                    <div className="rCol1_6">
                      <label htmlFor="actualCreditSubsequentsTranchesRowDate">
                        Data
                      </label>
                      <input
                        type="date"
                        id="actualCreditSubsequentsTranchesRowDate"
                        name="actualCreditSubsequentsTranchesRowDate"
                        value={props.actualCreditSubsequentsTranchesRowDate}
                        onChange={
                          props.handleActualCreditSubsequentsTranchesRowDateChange
                        }
                        min="2002-01-01"
                      />
                    </div>
                    <div className="rCol2_6">
                      <label htmlFor="actualCreditSubsequentsTranchesValue">
                        Wartość
                      </label>
                      <input
                        type="number"
                        pattern="\d+"
                        id="actualCreditSubsequentsTranchesRowValue"
                        name="actualCreditSubsequentsTranchesRowValue"
                        value={props.actualCreditSubsequentsTranchesRowValue}
                        onChange={
                          props.handleActualCreditSubsequentsTranchesRowValueChange
                        }
                        onFocus={props.handleFocus}
                      />
                    </div>
                    <div className="rCol3_6">
                      <label
                        htmlFor="actualCreditSubsequentsTranchesRowCurrency"
                        className="currencyTitle"
                      >
                        Waluta
                      </label>
                      <select
                        name="actualCreditSubsequentsTranchesRowCurrency"
                        id="actualCreditSubsequentsTranchesRowCurrency"
                        className="currencySelect"
                        value={props.actualCreditSubsequentsTranchesRowCurrency}
                        onChange={
                          props.handleActualCreditSubsequentsTranchesRowCurrencyChange
                        }
                      >
                        {props.analysisType === "chf" ? (
                          <option value="CHF">CHF</option>
                        ) : props.analysisType === "eur" ? (
                          <option value="EUR">EUR</option>
                        ) : props.analysisType === "dol" ? (
                          <option value="DOL">USD</option>
                        ) : (
                          ""
                        )}
                        <option value="PLN">PLN</option>
                      </select>
                    </div>
                    <div className="rCol4_6">
                      <button
                        className="buttonSubForm"
                        onClick={props.handleAddCreditSubsequentsTranchesChange}
                      >
                        DODAJ
                      </button>
                    </div>
                  </form>
                </div>
                <div className="subRow">
                  <CreditSubsequentsTranchesChangeData
                    creditSubsequentsTranchesChanges={
                      props.creditSubsequentsTranchesChanges
                    }
                    handleDeleteCreditSubsequentsTranchesChange={
                      props.handleDeleteCreditSubsequentsTranchesChange
                    }
                  />
                </div>
              </div>

              <div className="rowBlock">
                <div className="inputTitle">
                  Wcześniejsza spłata{" "}
                  {props.creditTypeText === "kredyt" ? "kredytu" : "pożyczki"}{" "}
                  [max: 15]
                </div>
                <div className="subRow">
                  <form className="subForm" id="changeLength" noValidate>
                    <div className="rCol1_6">
                      <label htmlFor="actualCreditEarlyRepaymentRowDate">
                        Data
                      </label>
                      <input
                        type="date"
                        id="actualCreditEarlyRepaymentRowDate"
                        name="actualCreditEarlyRepaymentRowDate"
                        value={props.actualCreditEarlyRepaymentRowDate}
                        onChange={
                          props.handleActualCreditEarlyRepaymentRowDateChange
                        }
                        min="2002-01-01"
                      />
                    </div>
                    <div className="rCol2_6">
                      <label htmlFor="actualCreditEarlyRepaymentRowValue">
                        Wartość
                      </label>
                      <input
                        type="number"
                        pattern="\d+"
                        id="actualCreditEarlyRepaymentRowValue"
                        name="actualCreditEarlyRepaymentRowValue"
                        value={props.actualCreditEarlyRepaymentRowValue}
                        onChange={
                          props.handleActualCreditEarlyRepaymentRowValueChange
                        }
                        onFocus={props.handleFocus}
                      />
                    </div>
                    <div className="rCol3_6">
                      <label
                        htmlFor="actualCreditEarlyRepaymentRowCurrency"
                        className="currencyTitle"
                      >
                        Waluta
                      </label>
                      <select
                        name="actualCreditEarlyRepaymentRowCurrency"
                        id="actualCreditEarlyRepaymentRowCurrency"
                        className="currencySelect"
                        value={props.actualCreditEarlyRepaymentRowCurrency}
                        onChange={
                          props.handleActualCreditEarlyRepaymentRowCurrencyChange
                        }
                      >
                        {props.analysisType === "chf" ? (
                          <option value="CHF">CHF</option>
                        ) : props.analysisType === "eur" ? (
                          <option value="EUR">EUR</option>
                        ) : props.analysisType === "dol" ? (
                          <option value="DOL">USD</option>
                        ) : (
                          ""
                        )}
                        <option value="PLN">PLN</option>
                      </select>
                    </div>
                    <div className="rCol4_6">
                      <button
                        className="buttonSubForm"
                        onClick={props.handleAddCreditEarlyRepaymentChange}
                      >
                        DODAJ
                      </button>
                    </div>
                  </form>
                </div>
                <div className="subRow">
                  <CreditEarlyRepaymentChangeData
                    creditEarlyRepaymentChanges={
                      props.creditEarlyRepaymentChanges
                    }
                    handleDeleteCreditEarlyRepaymentChange={
                      props.handleDeleteCreditEarlyRepaymentChange
                    }
                  />
                </div>
              </div>

              <div className="rowBlock">
                <div className="inputTitle">
                  Data zakończenia{" "}
                  {props.creditTypeText === "kredyt" ? "kredytu" : "pożyczki"}{" "}
                  (jezeli spłacono)
                </div>
                <div className="subRow">
                  <div className="rCol1_3">
                    <label htmlFor="creditEndDate">Data</label>
                    <input
                      type="date"
                      id="creditEndDate"
                      name="creditEndDate"
                      value={props.creditEndDate}
                      onChange={props.handleCreditEndDateChange}
                      min="2002-01-01"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="icoBox">
              <img
                src="./assets/add.png"
                className="ico"
                alt="Frankmierz"
              ></img>
            </div>
          </div>

          <div className="titleBox">
            <div className="titleCol1">
              <h2 className="calcSubtitle">Wykonaj analizę</h2>
            </div>
            <div className="titleCol2">
              <hr />
            </div>
          </div>
          <div className="fullRow">
            <div className="mainRow">
              <div className="row">
                <div className="rCol1_7">
                  <button className="buttonSubForm" onClick={props.doAnalysis}>
                    WYKONAJ
                  </button>
                </div>
              </div>
            </div>

            <div className="icoBox">
              <img
                src="./assets/progress.png"
                className="icoProgress"
                alt="Frankmierz"
              ></img>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default calcInputs;
